<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

onMounted(() => {
  // Apply saved theme on app load (persists across all pages including login)
  const theme = localStorage.getItem('theme') || 'light'
  if (theme === 'dark') {
    document.documentElement.classList.add('dark')
  } else if (theme === 'system') {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  } else {
    document.documentElement.classList.remove('dark')
  }
})
</script>
